import Modal from "react-modal";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  getListingUserSettingsThunk,
  ListingHoldersConcentrationKeysThunk,
  marketCapKeysThunk,
  realVolumeKeysThunk,
} from "../../Thunks";
import {
  ApiPutAsserListingAlertScoring,
  ApiPutHoldersConcentrationCapKeys,
  ApiPutListingMarketCapKeys,
  ApiPutListingRealVolumeKeys,
} from "../../Api";
import { Loading } from "../../Components";
import { numberWithComma } from "../../Utils/helper";

const customStyles = {
  content: {
    minHeight: "274px",
    width: "551px",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    right: "auto",
    bottom: "auto",
    padding: "0",
    border: "none",
    backgroundColor: "white",
    borderRadius: "24px",
    padding: "32px 0 35px 40px",
    lineHeight: "0",
  },
};

export const ListingAssetsChange = ({
  isAboveModalOpen,
  setIsAboveModalOpen,
  aboveField,
  editableAssetsItem,
  listingUserSettings,
}) => {
  const dispatch = useDispatch();

  const [enteredValue, setEnteredValue] = useState("");

  const [checkboxValue, setCheckboxValue] = useState(false);
  const [loading, serLoading] = useState(false);
  const [isValidationError, setIsValidationError] = useState(false);

  useEffect(() => {
    if (aboveField === "assetAlert" && listingUserSettings.length > 0) {
      // comes from user settings
      setEnteredValue(listingUserSettings[0].totalScoreAlertValue ?? "");
      setCheckboxValue(!!listingUserSettings[0].totalScoreAlert);
    } else if (editableAssetsItem) {
      // comes from editable item (holders, volume, etc.)
      setEnteredValue(editableAssetsItem.above ?? "");
      setCheckboxValue(!!editableAssetsItem.alert);
    }
  }, [aboveField, editableAssetsItem, listingUserSettings]);

  const acceptClick = () => {
    // const isValid = /^\d+$/.test(enteredValue);
    // const isValid = /^\d{1,3}(,\d{3})*$/.test(enteredValue);
    if (enteredValue) {
      serLoading(true);

      if (aboveField === "assetAlert") {
        ApiPutAsserListingAlertScoring({
          // id: editableAssetsItem.id,
          totalScoreAlertValue: Number(enteredValue.replace(/,/g, "")),
          totalScoreAlert: checkboxValue,
        })
          .then(() => {
            dispatch(getListingUserSettingsThunk());
            setIsValidationError(false);
            setIsAboveModalOpen(false);
            serLoading(false);
          })
          .catch(() => {
            serLoading(false);
          });
      } else if (aboveField === "addressesHoldingMore1PercentExceed") {
        ApiPutHoldersConcentrationCapKeys([
          {
            id: editableAssetsItem.id,
            above: enteredValue.replace(/,/g, ""),
            alert: checkboxValue,
          },
        ])
          .then(() => {
            dispatch(ListingHoldersConcentrationKeysThunk());
            setIsValidationError(false);
            setIsAboveModalOpen(false);
            serLoading(false);
          })
          .catch(() => {
            serLoading(false);
          });
      } else if (aboveField !== "avgMarketCapMonthAgoAbove") {
        ApiPutListingRealVolumeKeys([
          {
            id: editableAssetsItem.id,
            above: enteredValue.replace(/,/g, ""),
            alert: checkboxValue,
          },
        ])
          .then(() => {
            dispatch(realVolumeKeysThunk());
            setIsValidationError(false);
            setIsAboveModalOpen(false);
            serLoading(false);
          })
          .catch(() => {
            serLoading(false);
          });
      } else {
        ApiPutListingMarketCapKeys([
          {
            id: editableAssetsItem.id,
            above: enteredValue.replace(/,/g, ""),
            alert: checkboxValue,
          },
        ])
          .then(() => {
            dispatch(marketCapKeysThunk());
            setIsValidationError(false);
            setIsAboveModalOpen(false);
            serLoading(false);
          })
          .catch(() => {
            serLoading(false);
          });
      }
    } else {
      setIsValidationError(true);
    }
  };

  const validationErrorMessage = () => {
    if (isValidationError) {
      return (
        <p className="listing_error_message">Must contain only whole numbers</p>
      );
    }
  };
  const handleInputChange = (e) => {
    const value = e.target.value.replace(/,/g, "");
    if (!isNaN(value) && value.length <= 14) {
      setEnteredValue(value);
    }
  };
  const handleInputBlur = () => {
    setEnteredValue((prevValue) => numberWithComma(prevValue));
  };
  return (
    <Modal
      isOpen={isAboveModalOpen}
      onRequestClose={() => {
        setEnteredValue(editableAssetsItem.above);
        setCheckboxValue(editableAssetsItem.alert);
        setIsAboveModalOpen(false);
      }}
      style={customStyles}
    >
      <div className="listing_asset_modal_head">
        <h2 className="listing_asset_modal_title">
          {aboveField === "assetAlert"
            ? "Scoring Alert"
            : aboveField === "volumeAbove"
            ? "Volume 24h Above"
            : aboveField === "currentVsHighAbove"
            ? "Current Price vs High Price Above"
            : aboveField === "avgMarketCapMonthAgoAbove"
            ? "Average Market Cap Last 30 Days Above"
            : aboveField === "24hVolOnRepExchangesBinanceAbove"
            ? "Rep Exchanges + Binance Vol 24h Above"
            : aboveField === "averageDailyVolumeOverThePast3MonthsAbove"
            ? "Average Daily Volume Last 3 Months Above"
            : aboveField === "addressesHoldingMore1PercentExceed"
            ? "Addresses Holding > 1% Exceed"
            : "Reputable Exchanges Volume 24h Above"}
        </h2>

        <i
          className="icon-close listing_modal_close_icon"
          onClick={() => setIsAboveModalOpen(false)}
        ></i>
      </div>
      <div className="listing_asset_modal_money_field_wrapper">
        {validationErrorMessage()}
        <input
          type="text"
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          value={
            enteredValue
              ? enteredValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : 0
          }
          className="listing_asset_modal_money_field"
        />
      </div>
      <div className="listing_change_alert_wrapper">
        <input
          type="checkbox"
          checked={checkboxValue}
          // onChange={()=>setCheckboxValue((val)=>!val)}
          onChange={() => setCheckboxValue((prevValue) => !prevValue)}
          className="listing_change_alert_checkbox"
        />
        <span className="listing_change_alert_text">
          {aboveField === "assetAlert"
            ? "Alert if the Scoring below the threshold"
            : aboveField === "sufficientVolumeIn"
            ? "Alert if the 24h Volume on Reputable Exchanges below the threshold"
            : aboveField === "currentVsHighAbove"
            ? "Alert if the Current Price vs High Price below the threshold"
            : aboveField === "avgMarketCapMonthAgoAbove"
            ? "Alert if the Average Market Cap Last 30 Days below the threshold"
            : aboveField === "24hVolOnRepExchangesBinanceAbove"
            ? "Alert if the 24h Volume on Reputable Exchanges + Binance below the threshold"
            : aboveField === "averageDailyVolumeOverThePast3MonthsAbove"
            ? "Alert if the Average Daily Volume Last 3 Months below the threshold"
            : aboveField === "addressesHoldingMore1PercentExceed"
            ? "Alert if the Addresses Holding >1% exceed the threshold"
            : "Alert if the 24h Volume below the threshold"}
        </span>
      </div>
      <div className="listing_modal_submit_wrapper">
        <button onClick={acceptClick} className="listing_modal_submit">
          ACCEPT {loading ? <Loading /> : null}
        </button>
      </div>
    </Modal>
  );
};
